import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function Legal() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
            Legal
          </h1>

          <p className="text-gray-600 mb-8">
            <strong>Effective Date:</strong> 11 March 2026
          </p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              Welcome to FishBox Studios ("we," "us," or "our"). This page contains our Terms of Service and Privacy Policy, which govern your use of our website located at fishboxstudios.com.
            </p>

            <p className="text-gray-700 leading-relaxed mb-8">
              By accessing or using this website, you agree to these Terms of Service and acknowledge this Privacy Policy.
            </p>

            <h2 className="text-3xl font-bold mb-6 mt-12" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="terms-of-service">1. Terms of Service</a>
            </h2>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="acceptance-of-terms">1.1 Acceptance of Terms</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              By accessing or using our website, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you must not use the website.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="use-of-website">1.2 Use of the Website</a>
            </h4>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>You agree to use the website only for lawful purposes.</li>
              <li>You may not use the website in any way that could damage, disable, overburden, or impair the site or interfere with any other user's use of the site.</li>
              <li>You may not attempt to gain unauthorized access to any part of the website, the server on which it is hosted, or any networks or systems connected to the website.</li>
            </ul>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="intellectual-property">1.3 Intellectual Property</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-4">
              All content on this website, including text, graphics, logos, images, artwork, game designs, rules, and other materials, is owned by FishBox Studios or its licensors and is protected by applicable intellectual property laws.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              You may not reproduce, distribute, modify, create derivative works from, publicly display, or otherwise use any content from this website without our prior written permission.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="user-submissions">1.4 User Submissions</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you submit feedback, suggestions, ideas, or other content to us (for example, via a contact form or email), you grant us a non‑exclusive, royalty‑free, worldwide license to use and incorporate that content to develop and improve our games, services, or website.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              You agree not to submit any content that is unlawful, abusive, defamatory, infringing, or otherwise violates the rights of others.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="website-availability">1.5 Website Availability and Changes</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              We aim to keep the website available and functioning properly, but we do not guarantee that it will be uninterrupted, error‑free, or secure. We may modify, suspend, or discontinue any part of the website at any time without notice.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="disclaimer-of-warranties">1.6 Disclaimer of Warranties</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              The website and all content are provided on an "as is" and "as available" basis, without warranties of any kind, whether express or implied. To the fullest extent permitted by law, we disclaim all implied warranties, including warranties of merchantability, fitness for a particular purpose, and non‑infringement.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="limitation-of-liability">1.7 Limitation of Liability</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              To the fullest extent permitted by law, FishBox Studios will not be liable for any indirect, incidental, consequential, special, or punitive damages arising out of or relating to your use of the website.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="third-party-links">1.8 Links to Third‑Party Websites</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              Our website may contain links to third‑party websites for your convenience. We do not control and are not responsible for the content, policies, or practices of any third‑party websites.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="governing-law">1.9 Governing Law</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              These Terms are governed by and construed in accordance with the laws of the United States and the State of North Carolina, without regard to conflict of law principles.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="changes-to-terms">1.10 Changes to the Terms</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              We may update these Terms from time to time. When we do, we will revise the "Effective Date" at the top of this page. Your continued use of the website after changes are posted constitutes your acceptance of the revised Terms.
            </p>

            <h2 className="text-3xl font-bold mb-6 mt-12" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="privacy-policy">2. Privacy Policy</a>
            </h2>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="overview">2.1 Overview</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              This Privacy Policy explains how we collect, use, and protect information when you use our website. By using the website, you acknowledge that you have read and understood this Policy.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="information-we-collect">2.2 Information We Collect</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-4">
              We may collect the following types of information:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>
                <strong>Information you voluntarily provide,</strong> such as your name and email address, when you contact us or sign up for updates.
              </li>
              <li>
                <strong>Technical information automatically collected</strong> from your browser or device, such as IP address, browser type, pages visited, and timestamps.
              </li>
              <li>
                <strong>Information from cookies or similar technologies</strong> used to support core site functionality and understand basic usage.
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-8">
              You can choose not to provide certain information, but this may limit your ability to use some features of the website.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="how-we-use-information">2.3 How We Use Information</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>Respond to your inquiries and messages.</li>
              <li>Send you updates or newsletters if you have requested them.</li>
              <li>Maintain and improve the website, including monitoring performance, troubleshooting, and analyzing general usage trends.</li>
            </ul>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="cookies">2.4 Cookies</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              Cookies are small text files stored on your device that help the website function and allow us to understand how visitors interact with the site. Most browsers allow you to refuse cookies or to alert you when cookies are being sent, though some site features may not work properly if cookies are disabled.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="data-security">2.5 Data Security</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              We use reasonable administrative, technical, and physical safeguards designed to help protect the information we collect from accidental or unlawful destruction, loss, alteration, or unauthorized access. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="childrens-privacy">2.6 Children&apos;s Privacy</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              Our website is not directed to children under 13, and we do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.
            </p>

            <h4 className="text-2xl font-bold mb-4 mt-8" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="changes-to-privacy-policy">2.7 Changes to This Privacy Policy</a>
            </h4>
            <p className="text-gray-700 leading-relaxed mb-6">
              We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. When we do, we will update the &quot;Effective Date&quot; at the top of this page.
            </p>

            <h2 className="text-3xl font-bold mb-6 mt-12" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              <a id="contact-information">3. Contact Information</a>
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you have questions about these Terms of Service or this Privacy Policy, you may contact us at:
            </p>
            <div className="border-t border-gray-300 pt-8 mt-4">
              <p className="text-gray-700 leading-relaxed mb-1">
                <strong>FishBox Studios</strong>
              </p>
              <p className="text-gray-700 leading-relaxed mb-1">
                Sneads Ferry, North Carolina
              </p>
              <p className="text-gray-700 leading-relaxed mb-8">
                Email: <a href="mailto:inquiry@fishboxstudios.com" className="text-orange-600 hover:text-orange-700 transition-colors">inquiry@fishboxstudios.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}